import React from 'react';
import View from 'components/ui/view';
import Text from 'components/ui/text';

class ProductEngraving extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      line_1: '',
      line_2: '',
      line_3: ''
    };
    this.setLine1 = this.setLine.bind(this, 1);
    this.setLine2 = this.setLine.bind(this, 2);
    this.setLine3 = this.setLine.bind(this, 3);
    this.updateEngraving = this.updateEngraving.bind(this);
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  setLine(n, event) {
    this.setState({ [`line_${n}`]: event.target.value });
  }

  updateEngraving() {
    this.props.setEngraving({
      line_1: this.state.line_1,
      line_2: this.state.line_2,
      line_3: this.state.line_3
    });
  }

  toggleSelected() {
    const selected = !this.state.selected;
    this.setState({ selected });
    if (selected) this.updateEngraving();
    else this.props.setEngraving(null);
  }

  render() {
    const price = this.props.product.engraving.price.toFixed(2);

    return (
      <div className="product-engraving__container">
        <div className="row">
          <div className="col-xs-8">
            <input
              type="checkbox"
              id="hasEngraving"
              name="hasEngraving"
              checked={this.state.selected}
              onChange={this.toggleSelected}
            />
            <label htmlFor="hasEngraving" className="clickable">
              <View inlineBlock padding={{ sides: 'xs' }}>
                <Text tag="span" title weight="med" size="xs">
                  Custom Engraving
                </Text>
              </View>
            </label>
          </div>
          <div className="col-xs text-right">
            <Text tag="span" title secondary size="xs">
              +${price}
            </Text>
          </div>
        </div>

        {this.state.selected && (
          <View padding={{ top: 'sm' }}>
            <input
              type="text"
              className="product-engraving__input"
              value={this.state.line_1}
              onChange={this.setLine1}
              onBlur={this.updateEngraving}
              placeholder="Enter text (20 character max per line)"
              maxLength={20}
            />
            <input
              type="text"
              className="product-engraving__input"
              value={this.state.line_2}
              onChange={this.setLine2}
              onBlur={this.updateEngraving}
              maxLength={20}
            />
            <input
              type="text"
              className="product-engraving__input"
              value={this.state.line_3}
              onChange={this.setLine3}
              onBlur={this.updateEngraving}
              maxLength={20}
            />
          </View>
        )}
      </div>
    );
  }
}

export default ProductEngraving;



// WEBPACK FOOTER //
// ./shared/components/product/engraving.js